import React from "react";
import { CardContainer, CardGalleryContainer } from "properties/propertyCard/components/PropertyCardComponents";
import { NoSsr } from "@material-ui/core";
import { Link } from "react-router-dom";
import { CommunityCardHeader } from "communities/community-page/_components/card/community-card-header";
import { TCommunityCard } from "admin/communities/_models/CommunitiesMdl";
import { CommunityCardGallery } from "communities/community-page/_components/card/community-card-gallery";
import { CommunityCardInfos } from "communities/community-page/_components/card/community-card-infos";
import { URLS } from "_configs/URLS";

type Props = {
    community: TCommunityCard;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

export default function CommunityCard({ community, onMouseEnter, onMouseLeave }: Props) {
    return (
        <CardContainer
            className={"shadow-[0px_0px_5px_0px_#1A3A454D] hover:shadow-[0px_0px_8px_0px_#1A3A454D]"}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <Link to={URLS.community(community.localized.urlAlias)}>
                <NoSsr>
                    <CommunityCardHeader />
                </NoSsr>
                <CardGalleryContainer>
                    <CommunityCardGallery
                        community={{
                            _id: community._id,
                            photos: community?.photos ?? [],
                        }}
                    />
                </CardGalleryContainer>
                <CommunityCardInfos community={community} />
            </Link>
        </CardContainer>
    );
}
